import React, { useState } from 'react';
import StatusContext from '../../../contexts/StatusContext'
import StockContext from '../../../contexts/StocksContext'
import './stockssymbols.css';

const StocksSymbols = () => {

  const [error, setError] = useState('');

  let {
    stockSymbols,
    setStockSymbols,
    setShowSymbolsDialog,
    setNewStockSymbols,
    selectedSymbolsIndex,
    newstockSymbols,
    addSymbolsGroup, 
    setAddSymbolsGroup,
    onSaveSymbols,
 
  } = React.useContext(StockContext);

   let {
    changeLanguageEnglish,
  } = React.useContext(StatusContext);

  // Validate stock symbol format (basic validation)
  const isValidSymbol = (symbol) => {
    const symbolRegex = /^[A-Za-z]{1,5}$/;
    return symbolRegex.test(symbol.trim());
  };

  
  // Handle input change for a specific symbol
  const handleSymbolChange = (index, value) => {
    const newSymbols = [...stockSymbols];
    newSymbols[index] = value.toUpperCase();
    setStockSymbols(newSymbols);
    setError('');
  };


  // Add a new symbol input field
  const addSymbol = () => {
    if (stockSymbols.length < 10) {  
      if (stockSymbols.length  === 0 || stockSymbols[stockSymbols.length -1] !== '')
          setStockSymbols([...stockSymbols, '']);
    }
  };

  // Remove a symbol input field
  const removeSymbol = (index) => {
    if (stockSymbols.length > 1) {
      const newSymbols = stockSymbols.filter((_, i) => i !== index);
      setStockSymbols(newSymbols);
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {

    e.preventDefault();
    
    // Filter out empty symbols
    const validSymbols = stockSymbols.filter(symbol => symbol.trim() !== '');
    
    if (validSymbols.length === 0) {
      setError('Please enter at least one stock symbol');
      return;
    }

    // Validate all symbols
    const invalidSymbols = validSymbols.filter(symbol => !isValidSymbol(symbol));
    
    if (invalidSymbols.length > 0) {
      setError(`Invalid stock symbols: ${invalidSymbols.join(', ')}. Symbols should be 1-5 letters.`);
      return;
    }

    // Remove duplicates
    const uniqueSymbols = [...new Set(validSymbols)];
    
    /*
    if (uniqueSymbols.length !== validSymbols.length) {
      setStockSymbols([...uniqueSymbols, ...Array(stockSymbols.length - uniqueSymbols.length).fill('')]);
      return;
    }
    */
     

    // Success - process the symbols
    setStockSymbols(uniqueSymbols);
    

    let a = [...newstockSymbols]
    if (addSymbolsGroup)
    {
      a.push([])
      a[a.length-1] = uniqueSymbols
    }
    else
    {
      a[selectedSymbolsIndex] = uniqueSymbols
    }
    setNewStockSymbols(a)
    setAddSymbolsGroup(false)
    
    setError('');
    setShowSymbolsDialog(false)
    onSaveSymbols(a)

  };


  return (
    <div className="stock-symbol-input">
    
      <p className="subtitle">Enter up to 10 stock symbols (e.g., AAPL, GOOGL, MSFT)</p>
      
      <form onSubmit={handleSubmit}>
        {
          stockSymbols.length > 0 &&
        <div className="symbols-container">
          {stockSymbols.map((symbol, index) => (
            <div key={index} className="symbol-input-group">
              <input
                type="text"
                value={symbol}
                onChange={(e) => handleSymbolChange(index, e.target.value)}
                placeholder="Enter symbol (e.g., AAPL)"
                className={`symbol-input ${
                  symbol && !isValidSymbol(symbol) ? 'error' : ''
                }`}
                maxLength={5}
              />
              {stockSymbols.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeSymbol(index)}
                  className="remove-btn"
                  aria-label="Remove symbol"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      }

        <div className="controls">
          {stockSymbols.length < 10 && (
            <button
              type="button"
              onClick={addSymbol}
              className="add-btn"
            >
              {changeLanguageEnglish('stocks', 'addanothersymbol')}
            </button>
          )}

            <button type="submit" className="submit-btn"  onClick={handleSubmit}>
              {changeLanguageEnglish('stocks', 'finishsymbols')}
            </button>
          
        </div>
        
        
        {error && <div className="error-message">{error}</div>}

        <div className="info">
          <p><strong>{changeLanguageEnglish('stocks', 'currentsymbols')}</strong> {stockSymbols.filter(s => s.trim()).join(', ') || 'None'}</p>
          <p><strong>Remaining slots:</strong> {10 - stockSymbols.length}</p>
        </div>

      </form>
    </div>
  );
};

export default StocksSymbols;